<template>
  <div>

    <v-navigation-drawer v-if="isLoggedIn"
      v-model="drawer"
      :mini-variant="mini"
      permanent
      color="#1b1b1b"
      dark
      app
      class="custom-scroll">

      <v-list-item :class="mini ? 'px-2 pt-2' : 'px-2'">
          <v-img :src="hqLogo" alt="Welcome to Harlequin" class="mx-auto" />
      </v-list-item>

      <v-list shaped>
        <template v-for="item in items">
        
          <v-list-item
            v-if="item.roles && item.roles.includes(currentRole) && item.icon != ''"
            :key="item.text"
            :id="item.id"
            active-class="orange--text"
            route :to="item.route"
            @click="clearData(item.id)"
            :disabled="editingForm || editingProcess || editingReport">

            <v-list-item-action>
              <v-badge 
                v-if="item.content > 0"
                overlap
                color="#f87723"
                :content="item.content"
                :value="item.content"
              >
                <v-icon>{{ item.icon }}</v-icon>
              </v-badge>
              <v-icon v-if="item.content <= 0">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              <span v-if="item.icon == ''" class="font-weight-bold">{{ $t(item.text) }}</span>
              <span v-if="item.icon != ''">{{ $t(item.text) }}</span>
            </v-list-item-title>

          </v-list-item>

          <!-- Headings -->
          <v-list-item
            v-if="item.roles && item.roles.includes(currentRole) && item.icon == ''"
            :key="item.text"
            :disabled="editingForm || editingProcess || editingReport">

            <v-list-item-action>
              <v-icon v-if="item.content <= 0">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              <span v-if="item.icon == ''" class="font-weight-bold">{{ $t(item.text) }}</span>
              <span v-if="item.icon != ''">{{ $t(item.text) }}</span>
            </v-list-item-title>

          </v-list-item>

          <v-list-item
            v-if="!item.roles && item.icon != ''"
            :key="item.text"
            :id="item.id"
            active-class="orange--text"
            route :to="item.route"
            @click="clearData(item.id)"
            :disabled="editingForm || editingProcess || editingReport">

            <v-list-item-action>
              <v-badge 
                v-if="item.content > 0"
                overlap
                color="#f87723"
                :content="item.content"
                :value="item.content"
              >
                <v-icon>{{ item.icon }}</v-icon>
              </v-badge>
              <v-icon v-if="item.content <= 0">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              <span v-if="item.icon == ''" class="font-weight-bold">{{ $t(item.text) }}</span>
              <span v-if="item.icon != ''">{{ $t(item.text) }}</span>
            </v-list-item-title>

          </v-list-item>

          <!-- Headings -->
          <v-list-item
            v-if="!item.roles && item.icon == ''"
            :key="item.text"
            :disabled="editingForm || editingProcess || editingReport">

            <v-list-item-action>
              <v-icon v-if="item.content <= 0">{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-title>
              <span v-if="item.icon == ''" class="font-weight-bold">{{ $t(item.text) }}</span>
              <span v-if="item.icon != ''">{{ $t(item.text) }}</span>
            </v-list-item-title>

          </v-list-item>

        </template>
      </v-list>

      <p v-if="!mini" class="rsl-copyright text-center">VERSION: 2.0.0</p>
      <p v-if="!mini" class="rsl-copyright text-center">© Copyright 2020-{{currentYear}} Rabbit Software Limited. All Rights Reserved.</p>

    </v-navigation-drawer>

    <v-app-bar v-if="isLoggedIn"
      app
      color="#f87723"
      dark>

      <v-app-bar-nav-icon @click.stop="setWidth"></v-app-bar-nav-icon>
      <v-toolbar-title
        style="width: 800px"
        class="m1-0 p1-4">

        <span class="hidden-sm-and-down">{{ $t($route.meta.title) }} <span v-if="$route.name == 'ViewTask' && taskName != ''">> {{ taskName }} (Case #{{ caseId }})</span></span>

      </v-toolbar-title>

      <v-spacer />

      <div>{{$t('GENERAL.LOGGED_IN')}} {{ loggedInUser.authenticatedUser }}</div>
      <v-btn 
        icon 
        v-on:click="openSettings">
        <v-icon>mdi-cog-outline</v-icon>
      </v-btn>
      <v-btn 
        icon 
        v-on:click="logout"
        :disabled="editingForm || editingProcess || editingReport">
        <v-icon>mdi-logout</v-icon>
      </v-btn>

    </v-app-bar>

    <v-dialog
      transition="dialog-top-transition"
      max-width="800"
      v-model="settingsDialog"
      :retain-focus="false"
      persistent
    >
    <template>
      <v-card>
        <v-toolbar
          color="#f87723"
          dark
        >{{$t('SETTINGS.USER_SETTINGS')}}</v-toolbar>
        <v-card-title>
          {{$t('SETTINGS.CHANGE_PASSWORD')}}
        </v-card-title>
        <v-card-text>
          <div>{{$t('SETTINGS.CHANGE_PASSWORD_TEXT')}}</div>
          <v-btn
            class="mt-2"
            depressed
            color="success"
            @click="changePw()"
          >{{$t('SETTINGS.CHANGE_PASSWORD')}}</v-btn>
        </v-card-text>
        <v-card-title>
          {{$t('SETTINGS.LANGUAGE_HEADER')}}
        </v-card-title>
        <v-card-text>
          <div>{{$t('SETTINGS.LANGUAGE_TEXT')}}:</div>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="selectedLanguage"
                :items="supportedLanguages"
                item-text="name"
                item-value="code"
                label="Selected Language"
              ></v-select>
            </v-col>
          </v-row>
          <v-btn
            depressed
            color="success"
            @click="changeLanguage()"
          >{{$t('GENERAL.BTNS.SAVE')}}</v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="settingsDialog = false"
          >{{$t('GENERAL.BTNS.CLOSE')}}</v-btn>
        </v-card-actions>

        <v-snackbar
          v-model="snack"
          :timeout="3000"
          :color="snackColor"
        >
          {{ snackText }}

          <template v-slot:action="{ attrs }">
            <v-btn
              v-bind="attrs"
              text
              @click="snack = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </v-card>
    </template>
  </v-dialog>

  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="changePwDialog"
    :retain-focus="false"
    persistent
  >
    <template>
      <v-card>
        <v-toolbar
          color="#f87723"
          dark
        >{{ $t('SETTINGS.CHANGE_PASSWORD') }}</v-toolbar>
        <v-card-text>
          <div class="pt-5">{{ $t('SETTINGS.CHANGE_PASSWORD_TEXT2') }}</div>
          <div class="pt-5 red--text pb-4">{{ passwordPolicy }}</div>

          <v-form v-model="isFormValid" ref="changePwForm">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="password1"
                  :label="$t('ADMIN.USERS.FIELDS.PASS')"
                  :append-icon="showPass ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPass ? 'text' : 'password'"
                  @click:append="showPass = !showPass"
                  :rules="[rules.password]"
                  autocomplete="new-password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  onpaste="return false"
                  v-model="password2"
                  :label="$t('ADMIN.USERS.FIELDS.CONFIRM_PASS')"
                  :append-icon="showPass2 ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPass2 ? 'text' : 'password'"
                  @click:append="showPass2 = !showPass2"
                  :rules="password1 != '' ? [rules.required, rules.password, rules.passMatch] : []"
                  autocomplete="new-password"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            @click="cancelChangePw()"
          >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            text
            :disabled="!isFormValid"
            @click="confirmChangePw({password1, password2})"
          >{{ $t('GENERAL.BTNS.SAVE') }}</v-btn>
        </v-card-actions>

      </v-card>

    </template>
  </v-dialog>

  </div>

</template>

<script>

// Click event function for logout timer
function logoutTimer(ref) {
  if(typeof ref.timeOutObj != "undefined") {
    clearTimeout(ref.timeOutObj);
  }

  ref.timeOutObj = setTimeout(function(){   
    if(ref.$store.state.isLoggedIn) {
      ref.logout();
    }else {
      clearTimeout(ref.timeOutObj);
    }
  }, ref.autoLogoutTime);
}

import { mapGetters } from 'vuex';
import cryptojs from 'crypto-js';
export default {
  name: 'navbar',
  computed: {
    ...mapGetters(['loggedInUser', 'taskName', 'caseId', 'myTasksCount', 'unassignedTasksCount', 'ssoDetails', 'allHqConns', 'remoteTenants'])
  },
  data: function() {
    return {
      hqLogo: '',
      settingsDialog: false,
      selectedLanguage: this.$i18n.locale,
      supportedLanguages: [
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' },
        { code: 'pt', name: 'Português' },
        { code: 'es', name: 'Español' }
      ],
      isFormValid: false,
      changePwDialog: false,
      password1: '',
      password2: '',
      passwordPolicy: '',
      showPass: false,
      showPass2: false,
      timeOutObj: '',
      isLoggedIn: false,
      editingForm: false,
      editingProcess: false,
      editingReport: false,
      currentRole: null,
      drawer: null,
      mini: false,
      fab: false,
      counterInterval: null,
      samlAuthInterval: null,
      autoLogoutTime: 3600000,
      navItem: 'home',
      items: [
        {icon: 'mdi-home', text: 'MAIN_MENU.ITEMS.DASH', route: '/dashboard', content: -1, id: 'home'},
        {icon: 'mdi-account-supervisor', text: 'MAIN_MENU.ITEMS.ADMIN', route: '/admin', roles: ['adminRole','developerRole'], content: -1, id: 'admin'},
        {icon: 'mdi-file-multiple-outline', text: 'MAIN_MENU.ITEMS.DOCS', route: '/documents', content: -1, id: 'documents'},
        {icon: 'mdi-chart-box-outline', text: 'MAIN_MENU.ITEMS.REPORTS', route: '/reports', content: -1, id: 'reports'},
        {icon: '', text: 'MAIN_MENU.ITEMS.DESIGNER', model: false, roles: ['adminRole','developerRole'], content: -1},
        {icon: 'mdi-notebook-edit-outline', text: 'MAIN_MENU.ITEMS.TEMPLATES', route: '/templates', roles: ['adminRole','developerRole'], content: -1, id: 'templates'},
        {icon: 'mdi-clipboard-text-outline', text: 'MAIN_MENU.ITEMS.FORMS', route: '/form-builder', roles: ['adminRole','developerRole'], content: -1, id: 'forms'},
        {icon: 'mdi-code-braces', text: 'MAIN_MENU.ITEMS.PROCESSES', route: '/process-designer', roles: ['adminRole','developerRole'], content: -1, id: 'processes'},
        {icon: 'mdi-database-outline', text: 'MAIN_MENU.ITEMS.DB_TABLES', route: '/database-tables', roles: ['adminRole','developerRole'], content: -1, id: 'db-tables'},
        {icon: '', text: 'MAIN_MENU.ITEMS.CASES', model: false, content: -1},
        {icon: 'mdi-play', text: 'MAIN_MENU.ITEMS.START_CASE', route: '/start-new-case', content: -1, id: 'new-case'},
        {icon: 'mdi-fast-forward', text: 'MAIN_MENU.ITEMS.RUNNING_CASES', route: '/running-cases', roles: ['adminRole','supervisorRole','developerRole'], content: -1, id: 'running-cases'},
        {icon: 'mdi-inbox-multiple', text: 'MAIN_MENU.ITEMS.MY_TASKS', route: '/my-tasks', content: 0, id: 'my-tasks'},
        {icon: 'mdi-account-group', text: 'MAIN_MENU.ITEMS.TEAM_TASKS', route: '/team-tasks', roles: ['adminRole','supervisorRole','managerRole','developerRole'], content: -1, id: 'team-tasks'},
        {icon: 'mdi-inbox-arrow-down', text: 'MAIN_MENU.ITEMS.UNASSIGNED_TASKS', route: '/unassigned-tasks', content: 0, id: 'unnassigned-tasks'},
        {icon: 'mdi-collapse-all', text: 'MAIN_MENU.ITEMS.ALL_TASKS', route: '/all-tasks', roles: ['adminRole','supervisorRole','developerRole'], content: -1, id: 'all-tasks'},
        {icon: 'mdi-history', text: 'MAIN_MENU.ITEMS.HISTORIC_CASES', route: '/historic-cases', roles: ['adminRole','supervisorRole','developerRole'], content: -1, id: 'historic-cases'},
        {icon: '', text: 'MAIN_MENU.ITEMS.SUPPORT', model: false, content: -1},
        {icon: 'mdi-wrench-outline', text: 'MAIN_MENU.ITEMS.SUPPORT_REQUEST', route: '/support', content: 0, id: 'support'}
      ],
      currentYear: new Date().getFullYear(),
      rules: {
        required: value => !!value || 'Required',
        password: value => {
          if(value != '') {
            const pattern = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{10,}$/
            return pattern.test(value) || 'Passwords must meet the following criteria: Min 10 characters with at least 1 uppercase letter, 1 lowercase letter, 1 digit and 1 special character.'
          }else {
            return true;
          }
        },
        passMatch: value => value === this.password1 && value === this.password2 || 'The passwords do not match'
      },
      snack: false,
      snackColor: '',
      snackText: ''
    }
  },
  created() {
    // Language
    const storedLanguage = localStorage.getItem('userLanguage');
    const browserLanguage = navigator.language.substring(0, 2);
    
    if (storedLanguage) {
      this.$i18n.locale = storedLanguage;
      this.selectedLanguage = storedLanguage;
    } else if (this.supportedLanguages.some(lang => lang.code === browserLanguage)) {
      this.$i18n.locale = browserLanguage;
      this.selectedLanguage = browserLanguage;
    }

    document.onreadystatechange = () => {
      if (document.readyState === 'complete') {
        
        if(this.$store.state.isLoggedIn) {
          this.isLoggedIn = this.$store.state.isLoggedIn;
          this.currentRole = this.$store.state.currentRole;

          // Start timeout
          if(this.ssoDetails.msalEnabled) {
            this.autoLogoutTime = 1800000;
          }

          let ref = this;
          document.addEventListener('click', function() {
            document.addEventListener('click', logoutTimer(ref));
          });
        }

        if(this.$store.state.isLoggedIn && this.counterInterval == null) {
          this.refreshNotifications();
        }

        if(this.$store.state.isLoggedIn && this.ssoDetails.samlEnabled && this.samlAuthInterval == null) {
          this.checkSamlAuth();
        }

        this.getCounters();
      }
    };

    this.unsubscribe = this.$store.subscribe((mutation, state) => {

      // Listen for login
      if(mutation.type === 'LOGGED_IN_USER') {
        this.isLoggedIn = this.$store.state.isLoggedIn;
        this.currentRole = this.$store.state.currentRole;

        // Start timeout
        if(this.ssoDetails.msalEnabled) {
          this.autoLogoutTime = 1800000;
        }

        let ref = this;
        
        if(this.$store.state.isLoggedIn) {
          document.addEventListener('click', function() {
            document.addEventListener('click', logoutTimer(ref));
          });
        }

        if(this.counterInterval == null) {
          this.refreshNotifications();
        }
        if(this.ssoDetails.samlEnabled && this.samlAuthInterval == null) {
          this.checkSamlAuth();
        }
        this.getCounters();
      }

      // Listen for counter updates
      if(mutation.type === 'MY_TASKS_COUNT' || mutation.type === 'UNASSIGNED_TASKS_COUNT') {
        this.setBadges();
      }

      // Listen for logout
      if(mutation.type === 'LOGGED_OUT_USER') {
        this.isLoggedIn = false;
      }

      // Listen for form editing
      if(mutation.type === 'EDITING_FORM') {
        this.editingForm = state.tasks.editingForm;
      }

      // Listen for process editing
      if(mutation.type === 'EDITING_PROCESS') {
        this.editingProcess = state.process.editingProcess;
      }

      // Listen for report editing
      if(mutation.type === 'EDITING_REPORT') {
        this.editingReport = state.reports.editingReport;
      }

    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  mounted() {
    //Set logo
    this.hqLogo = process.env.VUE_APP_LOGO;
  },
  methods: {
    refreshHqConnections () {
      this.$store.dispatch('getAllHqConnections');
    },
    refreshRemoteTenants() {
      this.$store.dispatch('getAllRemoteTenants');
    },
    changePw() {
      this.refreshHqConnections();
      this.refreshRemoteTenants();

      this.passwordPolicy = this.$t('ADMIN.USERS.PASS_POLICY');
      this.changePwDialog = true;
    },
    async confirmChangePw(item) {
      this.changePwDialog = false;
      if(item.password1 != '') {
        let decipher = cryptojs.AES.decrypt(this.$store.state.xAuthToken, this.$store.state.randomKey);
        let credPayload = {
          'userId': this.loggedInUser.authenticatedUser,
          'credData': {
            'password': item.password1,
            'authenticatedUserPassword': decipher.toString(cryptojs.enc.Utf8)
          }
        };
        await this.$store.dispatch('updateUserCreds', credPayload).then( async () => {
          this.snackPwSuccess('Your password was updated successfully.');
          this.updateLog('Admin', 'Updated', 'User credentials updated for ' + this.loggedInUser.authenticatedUser + '.');

          if(this.remoteTenants.length > 0) {
            for(let i = 0; i < this.remoteTenants.length; i++) {
              let engineUrl = '';
              let engineName = '';
              let tenantName = '';
              
              for(let j = 0; j < this.allHqConns.length; j++) {
                if(this.remoteTenants[i].ENGINE_ID == this.allHqConns[j].ID) {
                  engineUrl = this.allHqConns[j].URL;
                  engineName = this.allHqConns[j].ENGINE_NAME;
                  tenantName = this.remoteTenants[i].TENANT_NAME;
                  break;
                }
              }

              if(engineUrl) {
                decipher = cryptojs.AES.decrypt(this.$store.state.extAuthToken, this.$store.state.randomKey);
                credPayload = {
                  'engineUrl': engineUrl,
                  'userId': this.loggedInUser.authenticatedUser,
                  'credData': {
                    'password': item.password1,
                    'authenticatedUserPassword': decipher.toString(cryptojs.enc.Utf8)
                  }
                };
                
                await this.$store.dispatch('remoteUpdateUserCreds', credPayload).then( () => {
                  this.updateLog('Admin', 'Updated', 'User credentials updated for ' + this.loggedInUser.authenticatedUser + ' on engine ' + engineName + ', tenant ' + tenantName + '.');
                  this.snackPwSuccess('User credentials successfully updated for ' + this.loggedInUser.authenticatedUser + ' on engine ' + engineName + '.');
                });
              }
            }
          }
        });
      }
    },
    cancelChangePw() {
      this.changePwDialog = false;
      this.password1 = '';
      this.password2 = '';
      this.$refs.changePwForm.resetValidation();
    },
    changeLanguage() {
      this.$i18n.locale = this.selectedLanguage;
      localStorage.setItem('userLanguage', this.selectedLanguage);
    },
    clearData(id) {
      if(id != this.navItem) {
        this.$store.commit('OP_LOG', []);
        this.$store.commit('COMPLETED_INSTANCES', []);
        this.$store.commit('ALL_TASKS', []);
        this.$store.commit('UNASSIGNED_TASKS', []);
        this.$store.commit('TEAM_TASKS', []);
        this.$store.commit('MY_TASKS', []);
        this.$store.commit('RUNNING_PROCESSES', []);
        this.$store.commit('PROCESSES', []);
        this.$store.commit('ALL_PROCESSES', []);
        this.$store.commit('ALL_PROCESS_XML', []);
        this.$store.commit('ALL_TABLES', []);
        this.$store.commit('ALL_FORMS', []);
        this.$store.commit('DOC_TEMPLATES', []);
        this.$store.commit('EMAIL_TEMPLATES', []);
        this.$store.commit('ALL_REPORTS', []);
        this.$store.commit('ALL_FILES', []);
        this.$store.commit('ALL_USERS', []);
        this.$store.commit('ALL_USERS_SPECIAL', []);
        this.$store.commit('ALL_PORTAL_USERS', []);
        this.$store.commit('ALL_GROUPS', []);
        this.$store.commit('HIST_DATES_CLEARED', false);
        this.navItem = id;
      }
    },
    refreshNotifications () {
      let ref = this;
      this.counterInterval = setInterval(function () {
        if(ref.isLoggedIn) {
          ref.getCounters();
        }
        if(!ref.isLoggedIn || typeof ref.isLoggedIn == 'undefined') {
          clearInterval(ref.counterInterval);
        }
      }, 60000);
    },
    checkSamlAuth() {
      let ref = this;
      this.samlAuthInterval = setInterval(function () {
        if(ref.isLoggedIn) {
          ref.$store.dispatch('samlAuthCheck');
        }
        if(!ref.isLoggedIn || typeof ref.isLoggedIn == 'undefined') {
          clearInterval(ref.samlAuthInterval);
        }
      }, 30000);
    },
    setWidth() {
      this.mini = !this.mini;
      if(this.mini) {
        // Set width to max
        let elems = document.querySelectorAll('.rsl-fixed-height');
        
        for(let e = 0; e < elems.length; e++) {
          elems[e].setAttribute('style', 'max-width: 100%;');
        }
      }else {
        // Set width
        let elems = document.querySelectorAll('.rsl-fixed-height');
        
        for(let e = 0; e < elems.length; e++) {
          elems[e].setAttribute('style', 'max-width: calc(100vw - 275px);');
        }
      }
    },
    getCounters() {
      if(this.isLoggedIn) {
        this.$store.dispatch('countMyTasks');
        this.$store.dispatch('countUnassignedTasks');
      }
    },
    setBadges() {
      for(let i = 0; i < this.items.length; i++) {
        if(this.items[i].text == 'My Tasks' && this.myTasksCount != null) {
          this.items[i].content = this.myTasksCount.toString();
        }
        if(this.items[i].text == 'Unassigned Tasks' && this.unassignedTasksCount != null) {
          this.items[i].content = this.unassignedTasksCount.toString();
        }
      }
    },
    openSettings() {
      this.settingsDialog = true;
    },
    async logout() {
      this.clearData('');
      this.updateLog('Admin', 'Logout', 'User ' + this.$store.state.currentUser + ' logged out.');
      await this.$store.dispatch('unlockAll').then( async () => {
        let payload = {
          'checkType': 'logoutUnlock'
        }
        await this.$store.dispatch('lockCheck', payload).then( async () => {
          let ref = this;
          document.removeEventListener('click', logoutTimer(ref));
          this.$store.commit('EDITING_FORM', false);
          this.$store.commit('EDITING_PROCESS', false);
          await this.$store.dispatch('logout')
          .then(() => {
            this.$router.push('/');
          });
        });
      });
    },
    snackPwSuccess(msg) {
      this.snack = true;
      this.snackTimeout = 5000;
      this.snackColor = 'success';
      this.snackText = msg;
    },
    snackPwError(msg) {
      this.snack = true;
      this.snackTimeout = 10000;
      this.snackColor = 'error';
      this.snackText = msg;
    },
    updateLog(cat, op, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': 0,
          'processName': null,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
  }
};
</script>

<style>
  .rsl-copyright {
    color: #f87723;
    font-size: 12px;
  }
  .custom-scroll {
    scrollbar-width: none;  /* Firefox */
    -ms-overflow-style: none;  /* Internet Explorer and Edge */
  }

  .custom-scroll::-webkit-scrollbar {
    display: none;  /* Chrome, Safari and Opera */
  }
</style>